<script>
  import { HStack, VStack, Spacer, Fixed, MediaQuery } from "./layout";
  import { Button, Icon } from "./widget";
  import { navigate } from "../router";

  export let guid;

  const edit = () => navigate(`#/wedding/${guid}/A?edit=true`);
  const view = () => navigate(`#/wedding/${guid}/A`);
</script>

<article>
  <MediaQuery query="(min-width: 481px)">
    <VStack alignment="center">
      <img src="/images/blog.svg" alt="blog" width="48px" />
      <span>Le Mariage - Blog</span>
      <img class="blog" src="/images/blog.jpg" alt="blog" />
      <button class="primary" on:click={edit}>Editer</button>
      <button class="primary" on:click={view}>Consulter</button>
    </VStack>
  </MediaQuery>
  <MediaQuery query="(max-width: 480px)">
    <Button action={edit}>
      <HStack alignment="center">
        <img src="/images/blog.svg" alt="blog" width="48px" />
        <span>Le Mariage - Blog (Edition)</span>
        <Spacer />
        <Icon name="chevron-right" />
        <Fixed />
      </HStack>
    </Button>
    <Button action={view}>
      <HStack alignment="center">
        <img src="/images/blog.svg" alt="blog" width="48px" />
        <span>Le Mariage - Blog (Lecture)</span>
        <Spacer />
        <Icon name="chevron-right" />
        <Fixed />
      </HStack>
    </Button>
  </MediaQuery>
</article>

<style>
  article {
    width: 100%;
    min-height: 48px;
    background-color: white;
    margin-top: 5px;
    padding-top: 5px;
  }
  span {
    margin-left: 1em;
  }
  img.blog {
    width: 100%;
  }
  @media (min-width: 481px) {
    article {
      padding: 1em;
      width: auto;
      min-width: 200px;
    }
    span {
      margin-left: 0;
    }
  }
</style>
